import { TASK_TYPE, ACTION_TYPE } from "../constants";

export const MODE_TYPE = {
  ARROW_MODE: "ARROW",
  PENCIL_MODE: "PENCIL"
};

const initialState = {
  flowId: "",
  hostName: "",
  theme: "",
  currentModeType: MODE_TYPE.ARROW_MODE,
  modes: [],
  classId: "",
  userName: "",
  pageCollection: [],
  selectedPageId: 0
};

const modeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === TASK_TYPE.INIT_WHITEBOARD) {
    const { modes, flowId, hostName, theme } = payload;
    return { ...state, flowId, hostName, theme, modes };
  }

  if (type === TASK_TYPE.CHOOSE_MODE_TYPE) {
    const { modeType } = payload;
    return { ...state, currentModeType: modeType };
  }

  if (type === ACTION_TYPE.ADD_MODE) {
    const { data, id, type, selectedPageId } = payload;

    let addedModes = [...state.modes];
    addedModes.push({ data, id, type, selectedPageId });

    return { ...state, modes: addedModes, selectedPageId };
  }

  if (type === TASK_TYPE.CHANGE_PAGE_NUMBER) {
    const { pageNumber } = payload;
    return { ...state, selectedPageId: pageNumber };
  }
  if (type === TASK_TYPE.PERFORM_UNDO) {
    const modesAfterUndo = payload.modes;
    return { ...state, modes: [...modesAfterUndo] };
  }

  if (type === TASK_TYPE.CLEAR_ALL) {
    const modesAfterClearAll = payload.modes;
    return { ...state, modes: [...modesAfterClearAll] };
  }

  return { ...state };

  // switch (type) {
  //   case "INIT_WHITEBOARD":
  //     console.log("hehe");
  //     const { modes, flowId, hostName, theme } = payload;

  //     console.log({ modes, flowId, hostName, theme });
  //     return { ...state, flowId, hostName, theme, modes };

  //   case TASK_TYPE.CHOOSE_MODE_TYPE:
  //     const { modeType } = payload;
  //     return { ...state, currentModeType: modeType };

  //   case ACTION_TYPE.ADD_MODE:
  //     const { data, id, type, selectedPageId } = payload;

  //     let addedModes = [...state.modes];
  //     addedModes.push({ data, id, type, selectedPageId });

  //     return { ...state, modes: addedModes, selectedPageId };

  //   case TASK_TYPE.CHANGE_PAGE_NUMBER:
  //     const { pageNumber } = payload;
  //     return { ...state, selectedPageId: pageNumber };

  //   case TASK_TYPE.PERFORM_UNDO:
  //     const modesAfterUndo = payload.modes;

  //     return { ...state, modes: [...modesAfterUndo] };

  //   case TASK_TYPE.CLEAR_ALL:
  //     const modesAfterClearAll = payload.modes;
  //     return { ...state, modes: [...modesAfterClearAll] };

  //   default:
  //     return { ...state };
  // }
};

export default modeReducer;
